var _path, _circle, _circle2, _circle3, _circle4, _circle5, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg5 = function Svg5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h100v100H1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 78.5,
    r: 12.5,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 12.5,
    transform: "rotate(90 23.5 23.5)",
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 23.5,
    r: 12.5,
    fill: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5,
    cy: 78.5,
    r: 12.5,
    transform: "rotate(90 78.5 78.5)",
    fill: "#000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 51.5,
    r: 12.5,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 1h100v100H1z"
  })));
};

export { Svg5 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyIiBoZWlnaHQ9IjEwMiIgdmlld0JveD0iMCAwIDEwMiAxMDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSIyMy41IiBjeT0iNzguNSIgcj0iMTIuNSIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMjMuNSIgY3k9IjIzLjUiIHI9IjEyLjUiIHRyYW5zZm9ybT0icm90YXRlKDkwIDIzLjUgMjMuNSkiIGZpbGw9ImJsYWNrIi8+CjxjaXJjbGUgY3g9Ijc4LjUiIGN5PSIyMy41IiByPSIxMi41IiBmaWxsPSJibGFjayIvPgo8Y2lyY2xlIGN4PSI3OC41IiBjeT0iNzguNSIgcj0iMTIuNSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNzguNSA3OC41KSIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iNTAuNSIgY3k9IjUxLjUiIHI9IjEyLjUiIGZpbGw9ImJsYWNrIi8+CjxyZWN0IHg9IjEiIHk9IjEiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBzdHJva2U9ImJsYWNrIi8+Cjwvc3ZnPgo=";